import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Box } from 'shared/mui/Box';
import { IconButton } from 'shared/mui/IconButtons';
import { Typography } from 'shared/mui/Typography';

import { BalanceRow } from './BalanceReportDatagrid';

type Props = {
  record: BalanceRow;
  isExpanded: boolean;
  toggleRow: (id: string) => void;
};

export const BalanceReportDatagridNameField: React.FC<Props> = ({
  record,
  isExpanded,
  toggleRow,
}) => {
  return (
    <Box
      sx={{
        paddingLeft: `${record.level * 32}px`,
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <IconButton
        onClick={(e) => {
          e.stopPropagation();
          toggleRow(record.id);
        }}
        size="small"
      >
        {isExpanded ? <ExpandMoreIcon /> : <ChevronRightIcon />}
      </IconButton>

      <Typography fontSize={14}>{record.name}</Typography>
    </Box>
  );
};
